import React from 'react';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '@/components/ui/select';
import { MapPin, Building2 } from 'lucide-react';

const DEFAULT_SITES = ['All Sites', 'Head Office', 'Factory A', 'Factory B', 'Warehouse East', 'Warehouse West'];
const DEFAULT_DEPTS = ['All Departments', 'Engineering', 'Procurement', 'R&D', 'Production', 'Quality', 'Finance'];

const SiteDeptFilter = ({
  site, onSiteChange, dept, onDeptChange,
  sites = DEFAULT_SITES, depts = DEFAULT_DEPTS,
  className = '',
}) => (
  <div className={`flex items-center gap-2 ${className}`}>
    <Select value={site || 'All Sites'} onValueChange={onSiteChange}>
      <SelectTrigger className="w-40 h-9" data-testid="site-filter">
        <MapPin className="h-3 w-3 mr-1 text-gray-400" />
        <SelectValue placeholder="Site" />
      </SelectTrigger>
      <SelectContent>
        {sites.map(s => <SelectItem key={s} value={s}>{s}</SelectItem>)}
      </SelectContent>
    </Select>
    <Select value={dept || 'All Departments'} onValueChange={onDeptChange}>
      <SelectTrigger className="w-44 h-9" data-testid="dept-filter">
        <Building2 className="h-3 w-3 mr-1 text-gray-400" />
        <SelectValue placeholder="Department" />
      </SelectTrigger>
      <SelectContent>
        {depts.map(d => <SelectItem key={d} value={d}>{d}</SelectItem>)}
      </SelectContent>
    </Select>
  </div>
);

export default SiteDeptFilter;
